/**
 * Environment selection.
 *
 * Defaults to production, so a build with no env set behaves exactly as before.
 * To point a local dev server at the testing backend, put this in .env:
 *
 *   REACT_APP_ENV=dev
 *
 * The REACT_APP_ prefix is required — create-react-app ignores every other
 * variable, which is why the old bare `API_URL=` line in .env never did anything.
 *
 * Note: customer-support-dev.herokuapp.com is dead — it 307-redirects to
 * production, so it is not a safe target. Use the -testing host.
 */
const PROD = process.env.REACT_APP_ENV !== "dev";

export const API_URL = PROD
  ? "https://cs-api.fidweb.net"
  : "https://customer-support-testing.herokuapp.com";

export const IMMOTECH_API_URL = PROD
  ? "https://immotech-2-prod.herokuapp.com"
  : "https://immotech-api.herokuapp.com";

export const AMARANT2_API_URL = PROD
  ? "https://amarant.herokuapp.com"
  : "https://amarant-dev2.herokuapp.com";

export const AMARANT_S3_CREDENTIALS = {
  bucketName: "amarant-rpa",
  region: "eu-central-1",
  accessKeyId: "AKIA5L7PZ7W5CHICD2X5",
  secretAccessKey: "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",
};
